import { create } from 'zustand';

interface DealBuilderAAAStore {
  aaa: [moment.Moment, number[]][],
  setAAA: (aaa: [moment.Moment, number[]][]) => void,
}

const useDealBuilderAAAStore = create<DealBuilderAAAStore>((set) => ({
  aaa: [],
  setAAA: (aaa: [moment.Moment, number[]][]) => set({ aaa }),
}));

export default useDealBuilderAAAStore;
